import { styled } from '@linaria/react';

export const MarketExpanderBetWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  position: relative;
`;

export const MarketExpanderBetName = styled.p<{ fontSize?: string }>`
  --oc-bet-name-font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};

  font-size: var(--oc-bet-name-font-size);
  display: inline-block;
  margin-right: 15px;
  white-space: normal;
  line-height: 18px;
  color: var(--ogm-text-body);
  text-align: right;
  overflow: hidden;
  max-height: 39px;
  text-overflow: ellipsis;
`;

export const OddsButtonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
`;
